import React from 'react'
import GlobalVariable from "../../../services/globalVar.js";

const ProfitandLoss = (props) => {
    const parentDatas = props;
    const currency = GlobalVariable.userDet.tenantConfig.currency;

  return (
    <div>
    {parentDatas.isRowView ? (
      <>
      {/* <div className="card card-borderless py-3">
        <div
          className="card-body card-borderless accordLeft p-2"
          style={{ height: "65vh", overflow: "auto" }}
        >
          {parentDatas.profitAndLossDatas.length !== 0 && (
            <table style={{ width: "100%" }}>
              <thead
                style={{
                  position: "sticky",
                  top: "-9px",
                  zIndex: 100,
                  boxShadow:
                    "-1px -20px 5px 0px rgba(255,255,255,1)",
                }}
              >
                <tr style={{ backgroundColor: "#EAF2E3" }}>
                  <th></th>
                  {parentDatas.profitAndLossDatas?.monthYear.map(
                    (month, index) => (
                      <th
                        className="text-end"
                        key={index}
                        style={{ fontWeight: "bold" }}
                      >
                        {month}
                      </th>
                    )
                  )}
                </tr>
              </thead>
              <tbody>
                {parentDatas.profitAndLossDatas?.coaTypes.map((type) =>
                  type.coaTypeName ? (
                    <React.Fragment key={type.typeID}>
                      <tr style={{ fontWeight: "bold" }}>
                        <td>
                          <h5 className="m-0">
                            {type.coaTypeName}
                          </h5>
                        </td>
                      </tr>
                      {type.coaCategoryList.map((category) => (
                        <React.Fragment key={category.categoryID}>
                          <tr
                            onClick={() =>
                              parentDatas.toggleCategory(category.categoryID)
                            }
                            style={{
                              cursor: "pointer",
                              fontWeight: "bold",
                            }}
                          >
                            <td>
                              <span className="d-flex align-items-center">
                                {category.coaCategoryName}{" "}
                                <i
                                  className={`pi ${
                                    parentDatas.expandedCategories[
                                      category.categoryID
                                    ]
                                      ? "pi-angle-down"
                                      : "pi-angle-right"
                                  } ms-2`}
                                ></i>
                              </span>
                            </td>
                            {category?.monthlyTotal.map(
                              (totalAmount, index) => (
                                <td
                                  key={index}
                                  className="text-end"
                                  style={{
                                    border: "none",
                                    color:
                                      totalAmount < 0
                                        ? "red"
                                        : "inherit",
                                  }}
                                >
                                  {GlobalVariable.userDet
                                    .tenantConfig.currency +
                                    " " +
                                    totalAmount.toFixed(2)}
                                </td>
                              )
                            )}
                          </tr>
                          {parentDatas.expandedCategories[
                            category.categoryID
                          ] &&
                            category.masCOAList.map((item) => (
                              <tr key={item.coaMasID}>
                                <td className="ps-3">
                                  {item.coaName}
                                </td>
                                {item.monthlyAmount.map(
                                  (amount, index) => (
                                    <td
                                      key={index}
                                      className="text-end"
                                      style={{
                                        border: "none",
                                        color:
                                          amount < 0
                                            ? "red"
                                            : "inherit",
                                      }}
                                    >
                                      {GlobalVariable.userDet
                                        .tenantConfig.currency +
                                        " " +
                                        amount.toFixed(2)}
                                    </td>
                                  )
                                )}
                              </tr>
                            ))}
                        </React.Fragment>
                      ))}
                    </React.Fragment>
                  ) : null
                )}
              </tbody>
            </table>
          )}
        </div>
      </div> */}

      <div className="row">
      <div
          className="card card-borderless py-2 m-2"
          style={{ width: "99%", padding: "0 10px" }}
        >
          <h2 style={{ textAlign: "start" }}>Expenses</h2>
          <div
            className="d-flex justify-content-between p-2"
            style={{ backgroundColor: "#EAF2E3" }}
          >
            <strong className="m-0 d-inline-flex">
              Particular
            </strong>
            <strong className="m-0 d-inline-flex">
              Amount ({currency})
            </strong>
          </div>
          <table className="mb-4" style={{ width: "100%" }}>
            <thead>
              <tr style={{ backgroundColor: "transparent" }}>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(parentDatas.profitAndLossDatas2?.tradingTable) &&
                parentDatas.profitAndLossDatas2.tradingTable.map((type, i) => (
                  <React.Fragment key={i}>
                    {Array.isArray(type.subTradeTable) &&
                      type.subTradeTable.map((category, j) => (
                        <React.Fragment key={j}>
                          <tr
                            style={{
                              border: "1px solid rgb(224 224 224)",
                            }}
                          >
                            <td style={{ border: "none" }}>
                              <span className="d-flex align-items-center">
                                {category.particulars}
                              </span>
                            </td>
                            <td
                              className="text-end"
                              style={{
                                color:
                                  category?.amount < 0
                                    ? "red"
                                    : "inherit",
                              }}
                            >
                              {category?.amount.toFixed(2)}
                            </td>
                            <td style={{ border: "none" }}></td>
                          </tr>
                          {parentDatas.expandedCategories[j] &&
                            Array.isArray(category.subTradeTable) &&
                            category.subTradeTable.map(
                              (item, k) => (
                                <tr
                                  key={k}
                                  style={{
                                    border:
                                      "1px solid rgb(224 224 224)",
                                  }}
                                >
                                  <td className="ps-3">
                                    {item.parentParticular}
                                  </td>
                                  <td
                                    className="text-end"
                                    style={{
                                      color:
                                        item.amount < 0
                                          ? "red"
                                          : "inherit",
                                      border: "none",
                                    }}
                                  >
                                    {item?.amount.toFixed(2)}
                                  </td>
                                </tr>
                              )
                            )}
                        </React.Fragment>
                      ))}
                    <tr
                      style={{
                        border: "1px solid rgb(224 224 224)",
                      }}
                    >
                      <td style={{ border: "none" }}>
                        <span className="d-flex align-items-center">
                          {type.particulars}
                        </span>
                      </td>
                      <td style={{ border: "none" }}></td>
                      <td
                        className="text-end"
                        style={{
                          color:
                            type?.amount < 0 ? "red" : "inherit",
                          border: "none",
                        }}
                      >
                        {type?.amount?.toFixed(2)}
                      </td>
                    </tr>
                  </React.Fragment>
                ))}

              {Array.isArray(parentDatas.profitAndLossDatas2?.directCategory) &&
                parentDatas.profitAndLossDatas2.directCategory.map(
                  (type, i) => (
                    <React.Fragment key={i}>
                      <tr
                        style={{
                          cursor: "pointer",
                          border: "1px solid rgb(224 224 224)",
                        }}
                      >
                        <td
                          onClick={() =>
                            parentDatas.toggleCategory(type.categoryID)
                          }
                          style={{ border: "none" }}
                        >
                          <span className="d-flex align-items-center">
                            {type.coaCategoryName}
                            <i
                              className={`pi ${
                                parentDatas.expandedCategories[type.categoryID]
                                  ? "pi-angle-down"
                                  : "pi-angle-right"
                              } ms-2`}
                            ></i>
                          </span>
                        </td>
                        <td style={{ border: "none" }}></td>
                        <td
                          className="text-end"
                          style={{
                            color:
                              type?.total < 0 ? "red" : "inherit",
                            border: "none",
                          }}
                        >
                          {type?.total?.toFixed(2)}
                        </td>
                      </tr>
                      {parentDatas.expandedCategories[type.categoryID] &&
                        type.masCOAList.map((item) => (
                          <tr
                            key={item.coaMasID}
                            style={{
                              border: "1px solid rgb(224 224 224)",
                            }}
                          >
                            <td className="ps-3">{item.coaName}</td>
                            <td style={{ border: "none" }}></td>
                            <td
                              className="text-end"
                              style={{
                                color:
                                  item.amount < 0
                                    ? "red"
                                    : "inherit",
                                border: "none",
                              }}
                            >
                              {item.amount?.toFixed(2)}
                            </td>
                          </tr>
                        ))}
                    </React.Fragment>
                  )
                )}

              <tr style={{ border: "1px solid rgb(224 224 224)" }}>
                <td style={{ border: "none" }}>
                  <span className="d-flex align-items-center">
                    Gross Profit
                  </span>
                </td>
                <td style={{ border: "none" }}></td>
                <td
                  className="text-end"
                  style={{
                    color:
                    parentDatas.profitAndLossDatas2?.grossProfit < 0
                        ? "red"
                        : "inherit",
                    border: "none",
                  }}
                >
                  {parentDatas.profitAndLossDatas2?.grossProfit?.toFixed(2)}
                </td>
              </tr>

              <tr style={{ border: "1px solid rgb(224 224 224)" }}>
                <td style={{ border: "none", fontWeight: "bold" }}>
                  <span className="d-flex align-items-center">
                    Total
                  </span>
                </td>
                <td style={{ border: "none" }}></td>
                <td
                  className="text-end fw-bold"
                  style={{
                    color:
                    parentDatas.profitAndLossDatas2?.grossAmount < 0
                        ? "red"
                        : "inherit",
                    border: "none",
                  }}
                >
                  {parentDatas.profitAndLossDatas2?.grossAmount?.toFixed(2)}
                </td>
              </tr>

              <tr style={{ border: "1px solid rgb(224 224 224)" }}>
                <td style={{ border: "none" }}>
                  <span className="d-flex align-items-center">
                    Gross Loss
                  </span>
                </td>
                <td style={{ border: "none" }}></td>
                <td
                  className="text-end"
                  style={{
                    color:
                    parentDatas.profitAndLossDatas2.switchGrossProfit < 0
                        ? "red"
                        : "inherit",
                    border: "none",
                  }}
                >
                  {parentDatas.profitAndLossDatas2.switchGrossProfit?.toFixed(
                    2
                  )}
                </td>
              </tr>

              {Array.isArray(
                parentDatas.profitAndLossDatas2.inDirectCategory
              ) &&
              parentDatas.profitAndLossDatas2.inDirectCategory.map(
                  (type, i) => (
                    <React.Fragment key={i}>
                      <tr
                        style={{
                          cursor: "pointer",
                          border: "1px solid rgb(224 224 224)",
                        }}
                      >
                        <td
                          onClick={() =>
                            parentDatas.toggleCategory(type.categoryID)
                          }
                          style={{ border: "none" }}
                        >
                          <span className="d-flex align-items-center">
                            {type.coaCategoryName}
                            <i
                              className={`pi ${
                                parentDatas.expandedCategories[type.categoryID]
                                  ? "pi-angle-down"
                                  : "pi-angle-right"
                              } ms-2`}
                            ></i>
                          </span>
                        </td>
                        <td style={{ border: "none" }}></td>
                        <td
                          className="text-end"
                          style={{
                            color:
                              type?.total < 0 ? "red" : "inherit",
                            border: "none",
                          }}
                        >
                          {type?.total?.toFixed(2)}
                        </td>
                      </tr>
                      {parentDatas.expandedCategories[type.categoryID] &&
                        type.masCOAList.map((item) => (
                          <tr
                            key={item.coaMasID}
                            style={{
                              border: "1px solid rgb(224 224 224)",
                            }}
                          >
                            <td className="ps-3">{item.coaName}</td>
                            <td style={{ border: "none" }}></td>
                            <td
                              className="text-end"
                              style={{
                                color:
                                  item.amount < 0
                                    ? "red"
                                    : "inherit",
                                border: "none",
                              }}
                            >
                              {item.amount?.toFixed(2)}
                            </td>
                          </tr>
                        ))}
                    </React.Fragment>
                  )
                )}

              <tr style={{ border: "1px solid rgb(224 224 224)" }}>
                <td style={{ border: "none" }}>
                  <span className="d-flex align-items-center">
                    Net Profit
                  </span>
                </td>
                <td style={{ border: "none" }}></td>
                <td
                  className="text-end"
                  style={{
                    color:
                    parentDatas.profitAndLossDatas2?.netProfit < 0
                        ? "red"
                        : "inherit",
                    border: "none",
                  }}
                >
                  {parentDatas.profitAndLossDatas2?.netProfit?.toFixed(2)}
                </td>
              </tr>

              <tr style={{ border: "1px solid rgb(224 224 224)" }}>
                <td style={{ fontWeight: "bold" }}>
                  <span className="d-flex align-items-center">
                    Total
                  </span>
                </td>
                <td></td>
                <td
                  className="text-end fw-bold"
                  style={{
                    color:
                    parentDatas.profitAndLossDatas2?.netAmount < 0
                        ? "red"
                        : "inherit",
                  }}
                >
                  {parentDatas.profitAndLossDatas2?.netAmount?.toFixed(2)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        

       
      </div>
      <div className="row">
      <div
          className="card card-borderless py-2 m-2"
          style={{ width: "99%", padding: "0 10px" }}
        >
          <h2 style={{ textAlign: "start" }}>Income</h2>
          <div
            className="d-flex justify-content-between p-2"
            style={{ backgroundColor: "#EAF2E3" }}
          >
            <strong className="m-0 d-inline-flex">
              Particular{" "}
            </strong>

            <strong className="m-0 d-inline-flex">
              Amount ({currency})
            </strong>
          </div>
          <table className="mb-4 " style={{ width: "100%" }}>
            <thead>
              <tr style={{ backgroundColor: "transparent" }}>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(parentDatas.profitAndLossDatas1?.tradingTable) &&
                parentDatas.profitAndLossDatas1.tradingTable.map((type, i) => (
                  <React.Fragment key={i}>
                    {Array.isArray(type.subTradeTable) &&
                      type.subTradeTable.map((category, j) => (
                        <React.Fragment key={j}>
                          <tr
                            style={{
                              border: "1px solid rgb(224 224 224)",
                            }}
                          >
                            <td style={{ border: "none" }}>
                              <span className="d-flex align-items-center">
                                {category.particulars}{" "}
                              </span>
                            </td>
                            <td
                              className="text-end"
                              style={{
                                color:
                                  category?.amount < 0
                                    ? "red"
                                    : "inherit",
                              }}
                            >
                              {category?.amount.toFixed(2)}
                            </td>
                            <td style={{ border: "none" }}></td>
                          </tr>
                          {parentDatas.expandedCategories[j] &&
                            Array.isArray(category.subTradeTable) &&
                            category.subTradeTable.map(
                              (item, k) => (
                                <tr
                                  key={k}
                                  style={{
                                    border:
                                      "1px solid rgb(224 224 224)",
                                  }}
                                >
                                  <td className="ps-3">
                                    {item.parentParticular}
                                  </td>
                                  <td
                                    className="text-end"
                                    style={{
                                      border: "none",
                                      color:
                                        item?.amount < 0
                                          ? "red"
                                          : "inherit",
                                    }}
                                  >
                                    {item?.amount.toFixed(2)}
                                  </td>
                                </tr>
                              )
                            )}
                        </React.Fragment>
                      ))}
                    <tr
                      style={{
                        border: "1px solid rgb(224 224 224)",
                      }}
                    >
                      <td style={{ border: "none" }}>
                        <span className="d-flex align-items-center">
                          {type.particulars}{" "}
                        </span>
                      </td>
                      <td style={{ border: "none" }}></td>
                      <td
                        className="text-end"
                        style={{
                          border: "none",
                          color:
                            type?.amount < 0 ? "red" : "inherit",
                        }}
                      >
                        {type?.amount?.toFixed(2)}
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              {Array.isArray(parentDatas.profitAndLossDatas1?.directCategory) &&
                parentDatas.profitAndLossDatas1.directCategory.map(
                  (type, i) => (
                    <React.Fragment key={i}>
                      <tr
                        style={{
                          cursor: "pointer",
                          border: "1px solid rgb(224 224 224)",
                        }}
                      >
                        <td
                          onClick={() =>
                            parentDatas.toggleCategory(type.categoryID)
                          }
                          style={{ border: "none" }}
                        >
                          <span className="d-flex align-items-center ">
                            {type.coaCategoryName}{" "}
                            <i
                              className={`pi ${
                                parentDatas.expandedCategories[type.categoryID]
                                  ? "pi-angle-down"
                                  : "pi-angle-right"
                              } ms-2`}
                            ></i>
                          </span>
                        </td>
                        <td style={{ border: "none" }}></td>
                        <td
                          className="text-end"
                          style={{
                            border: "none",
                            color:
                              type?.total < 0 ? "red" : "inherit",
                          }}
                        >
                          {type?.total?.toFixed(2)}
                        </td>
                      </tr>

                      {parentDatas.expandedCategories[type.categoryID] &&
                        type.masCOAList.map((item) => (
                          <tr
                            key={item.coaMasID}
                            style={{
                              border: "1px solid rgb(224 224 224)",
                            }}
                          >
                            <td className="ps-3">{item.coaName}</td>
                            <td></td>
                            <td
                              className="text-end"
                              style={{
                                border: "none",
                                color:
                                  item.amount < 0
                                    ? "red"
                                    : "inherit",
                              }}
                            >
                              {item.amount?.toFixed(2)}
                            </td>
                          </tr>
                        ))}
                    </React.Fragment>
                  )
                )}
              <tr style={{ border: "1px solid rgb(224 224 224)" }}>
                <td style={{ border: "none" }}>
                  <span className="d-flex align-items-center">
                    Gross Loss
                  </span>
                </td>
                <td style={{ border: "none" }}></td>
                <td
                  className="text-end"
                  style={{
                    border: "none",
                    color:
                    parentDatas.profitAndLossDatas1?.grossProfit < 0
                        ? "red"
                        : "inherit",
                  }}
                >
                  {parentDatas.profitAndLossDatas1?.grossProfit?.toFixed(2)}
                </td>
              </tr>
              <tr style={{ border: "1px solid rgb(224 224 224)" }}>
                <td style={{ border: "none", fontWeight: "bold" }}>
                  <span className="d-flex align-items-center">
                    Total
                  </span>
                </td>
                <td style={{ border: "none" }}></td>
                <td
                  className="text-end fw-bold"
                  style={{
                    border: "none",
                    color:
                    parentDatas.profitAndLossDatas1?.grossAmount < 0
                        ? "red"
                        : "inherit",
                  }}
                >
                  {parentDatas.profitAndLossDatas1?.grossAmount?.toFixed(2)}
                </td>
              </tr>
              <tr style={{ border: "1px solid rgb(224 224 224)" }}>
                <td style={{ border: "none" }}>
                  <span className="d-flex align-items-center">
                    Gross Profit
                  </span>
                </td>
                <td style={{ border: "none" }}></td>
                <td
                  className="text-end"
                  style={{
                    border: "none",
                    color:
                    parentDatas.profitAndLossDatas1?.switchGrossProfit < 0
                        ? "red"
                        : "inherit",
                  }}
                >
                  {parentDatas.profitAndLossDatas1?.switchGrossProfit?.toFixed(
                    2
                  )}
                </td>
              </tr>
              {Array.isArray(
                parentDatas.profitAndLossDatas1?.inDirectCategory
              ) &&
              parentDatas.profitAndLossDatas1.inDirectCategory.map(
                  (type, i) => (
                    <React.Fragment key={i}>
                      <tr
                        style={{
                          cursor: "pointer",
                          border: "1px solid rgb(224 224 224)",
                        }}
                      >
                        <td
                          onClick={() =>
                            parentDatas.toggleCategory(type.categoryID)
                          }
                          style={{ border: "none" }}
                        >
                          <span className="d-flex align-items-center ">
                            {type.coaCategoryName}{" "}
                            <i
                              className={`pi ${
                                parentDatas.expandedCategories[type.categoryID]
                                  ? "pi-angle-down"
                                  : "pi-angle-right"
                              } ms-2`}
                            ></i>
                          </span>
                        </td>
                        <td style={{ border: "none" }}></td>
                        <td
                          className="text-end"
                          style={{
                            border: "none",
                            color:
                              type?.total < 0 ? "red" : "inherit",
                          }}
                        >
                          {type?.total?.toFixed(2)}
                        </td>
                      </tr>

                      {parentDatas.expandedCategories[type.categoryID] &&
                        type.masCOAList.map((item) => (
                          <tr
                            key={item.coaMasID}
                            style={{
                              border: "1px solid rgb(224 224 224)",
                            }}
                          >
                            <td className="ps-3">{item.coaName}</td>
                            <td></td>
                            <td
                              className="text-end"
                              style={{
                                border: "none",
                                color:
                                  item.amount < 0
                                    ? "red"
                                    : "inherit",
                              }}
                            >
                              {item.amount?.toFixed(2)}
                            </td>
                          </tr>
                        ))}
                    </React.Fragment>
                  )
                )}
              <tr style={{ border: "1px solid rgb(224 224 224)" }}>
                <td style={{ border: "none" }}>
                  <span className="d-flex align-items-center">
                    Net Loss
                  </span>
                </td>
                <td style={{ border: "none" }}></td>
                <td
                  className="text-end"
                  style={{
                    border: "none",
                    color:
                    parentDatas.profitAndLossDatas1?.netProfit < 0
                        ? "red"
                        : "inherit",
                  }}
                >
                  {parentDatas.profitAndLossDatas1?.netProfit?.toFixed(2)}
                </td>
              </tr>
              <tr style={{ border: "1px solid rgb(224 224 224)" }}>
                <td style={{ border: "none", fontWeight:"bold" }}>
                  <span className="d-flex align-items-center">
                    Total
                  </span>
                </td>
                <td style={{ border: "none" }}></td>
                <td
                  className="text-end"
                  style={{
                    border: "none",
                    fontWeight:"bold",
                    color:
                    parentDatas.profitAndLossDatas1?.netAmount < 0
                        ? "red"
                        : "inherit",
                  }}
                >
                  {parentDatas.profitAndLossDatas1?.netAmount?.toFixed(2)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      
      </>
    ) : (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div
          className="card card-borderless py-2"
          style={{ width: "50%", padding: "0 10px" }}
        >
          <h2 style={{ textAlign: "center" }}>Expenses</h2>
          <div
            className="d-flex justify-content-between p-2"
            style={{ backgroundColor: "#EAF2E3" }}
          >
            <strong className="m-0 d-inline-flex">
              Particular
            </strong>
            <strong className="m-0 d-inline-flex">
              Amount ({currency})
            </strong>
          </div>
          <table className="mb-4" style={{ width: "100%" }}>
            <thead>
              <tr style={{ backgroundColor: "transparent" }}>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(parentDatas.profitAndLossDatas2?.tradingTable) &&
                parentDatas.profitAndLossDatas2.tradingTable.map((type, i) => (
                  <React.Fragment key={i}>
                    {Array.isArray(type.subTradeTable) &&
                      type.subTradeTable.map((category, j) => (
                        <React.Fragment key={j}>
                          <tr
                            style={{
                              border: "1px solid rgb(224 224 224)",
                            }}
                          >
                            <td style={{ border: "none" }}>
                              <span className="d-flex align-items-center">
                                {category.particulars}
                              </span>
                            </td>
                            <td
                              className="text-end"
                              style={{
                                color:
                                  category?.amount < 0
                                    ? "red"
                                    : "inherit",
                              }}
                            >
                              {category?.amount.toFixed(2)}
                            </td>
                            <td style={{ border: "none" }}></td>
                          </tr>
                          {parentDatas.expandedCategories[j] &&
                            Array.isArray(category.subTradeTable) &&
                            category.subTradeTable.map(
                              (item, k) => (
                                <tr
                                  key={k}
                                  style={{
                                    border:
                                      "1px solid rgb(224 224 224)",
                                  }}
                                >
                                  <td className="ps-3">
                                    {item.parentParticular}
                                  </td>
                                  <td
                                    className="text-end"
                                    style={{
                                      color:
                                        item.amount < 0
                                          ? "red"
                                          : "inherit",
                                      border: "none",
                                    }}
                                  >
                                    {item?.amount.toFixed(2)}
                                  </td>
                                </tr>
                              )
                            )}
                        </React.Fragment>
                      ))}
                    <tr
                      style={{
                        border: "1px solid rgb(224 224 224)",
                      }}
                    >
                      <td style={{ border: "none" }}>
                        <span className="d-flex align-items-center">
                          {type.particulars}
                        </span>
                      </td>
                      <td style={{ border: "none" }}></td>
                      <td
                        className="text-end"
                        style={{
                          color:
                            type?.amount < 0 ? "red" : "inherit",
                          border: "none",
                        }}
                      >
                        {type?.amount?.toFixed(2)}
                      </td>
                    </tr>
                  </React.Fragment>
                ))}

              {Array.isArray(parentDatas.profitAndLossDatas2?.directCategory) &&
                parentDatas.profitAndLossDatas2.directCategory.map(
                  (type, i) => (
                    <React.Fragment key={i}>
                      <tr
                        style={{
                          cursor: "pointer",
                          border: "1px solid rgb(224 224 224)",
                        }}
                      >
                        <td
                          onClick={() =>
                            parentDatas.toggleCategory(type.categoryID)
                          }
                          style={{ border: "none" }}
                        >
                          <span className="d-flex align-items-center">
                            {type.coaCategoryName}
                            <i
                              className={`pi ${
                                parentDatas.expandedCategories[type.categoryID]
                                  ? "pi-angle-down"
                                  : "pi-angle-right"
                              } ms-2`}
                            ></i>
                          </span>
                        </td>
                        <td style={{ border: "none" }}></td>
                        <td
                          className="text-end"
                          style={{
                            color:
                              type?.total < 0 ? "red" : "inherit",
                            border: "none",
                          }}
                        >
                          {type?.total?.toFixed(2)}
                        </td>
                      </tr>
                      {parentDatas.expandedCategories[type.categoryID] &&
                        type.masCOAList.map((item) => (
                          <tr
                            key={item.coaMasID}
                            style={{
                              border: "1px solid rgb(224 224 224)",
                            }}
                          >
                            <td className="ps-3">{item.coaName}</td>
                            <td style={{ border: "none" }}></td>
                            <td
                              className="text-end"
                              style={{
                                color:
                                  item.amount < 0
                                    ? "red"
                                    : "inherit",
                                border: "none",
                              }}
                            >
                              {item.amount?.toFixed(2)}
                            </td>
                          </tr>
                        ))}
                    </React.Fragment>
                  )
                )}

              <tr style={{ border: "1px solid rgb(224 224 224)" }}>
                <td style={{ border: "none" }}>
                  <span className="d-flex align-items-center">
                    Gross Profit
                  </span>
                </td>
                <td style={{ border: "none" }}></td>
                <td
                  className="text-end"
                  style={{
                    color:
                    parentDatas.profitAndLossDatas2?.grossProfit < 0
                        ? "red"
                        : "inherit",
                    border: "none",
                  }}
                >
                  {parentDatas.profitAndLossDatas2?.grossProfit?.toFixed(2)}
                </td>
              </tr>

              <tr style={{ border: "1px solid rgb(224 224 224)" }}>
                <td style={{ border: "none", fontWeight: "bold" }}>
                  <span className="d-flex align-items-center">
                    Total
                  </span>
                </td>
                <td style={{ border: "none" }}></td>
                <td
                  className="text-end fw-bold"
                  style={{
                    color:
                    parentDatas.profitAndLossDatas2?.grossAmount < 0
                        ? "red"
                        : "inherit",
                    border: "none",
                  }}
                >
                  {parentDatas.profitAndLossDatas2?.grossAmount?.toFixed(2)}
                </td>
              </tr>

              <tr style={{ border: "1px solid rgb(224 224 224)" }}>
                <td style={{ border: "none" }}>
                  <span className="d-flex align-items-center">
                    Gross Loss
                  </span>
                </td>
                <td style={{ border: "none" }}></td>
                <td
                  className="text-end"
                  style={{
                    color:
                    parentDatas.profitAndLossDatas2.switchGrossProfit < 0
                        ? "red"
                        : "inherit",
                    border: "none",
                  }}
                >
                  {parentDatas.profitAndLossDatas2.switchGrossProfit?.toFixed(
                    2
                  )}
                </td>
              </tr>

              {Array.isArray(
                parentDatas.profitAndLossDatas2.inDirectCategory
              ) &&
              parentDatas.profitAndLossDatas2.inDirectCategory.map(
                  (type, i) => (
                    <React.Fragment key={i}>
                      <tr
                        style={{
                          cursor: "pointer",
                          border: "1px solid rgb(224 224 224)",
                        }}
                      >
                        <td
                          onClick={() =>
                            parentDatas.toggleCategory(type.categoryID)
                          }
                          style={{ border: "none" }}
                        >
                          <span className="d-flex align-items-center">
                            {type.coaCategoryName}
                            <i
                              className={`pi ${
                                parentDatas.expandedCategories[type.categoryID]
                                  ? "pi-angle-down"
                                  : "pi-angle-right"
                              } ms-2`}
                            ></i>
                          </span>
                        </td>
                        <td style={{ border: "none" }}></td>
                        <td
                          className="text-end"
                          style={{
                            color:
                              type?.total < 0 ? "red" : "inherit",
                            border: "none",
                          }}
                        >
                          {type?.total?.toFixed(2)}
                        </td>
                      </tr>
                      {parentDatas.expandedCategories[type.categoryID] &&
                        type.masCOAList.map((item) => (
                          <tr
                            key={item.coaMasID}
                            style={{
                              border: "1px solid rgb(224 224 224)",
                            }}
                          >
                            <td className="ps-3">{item.coaName}</td>
                            <td style={{ border: "none" }}></td>
                            <td
                              className="text-end"
                              style={{
                                color:
                                  item.amount < 0
                                    ? "red"
                                    : "inherit",
                                border: "none",
                              }}
                            >
                              {item.amount?.toFixed(2)}
                            </td>
                          </tr>
                        ))}
                    </React.Fragment>
                  )
                )}

              <tr style={{ border: "1px solid rgb(224 224 224)" }}>
                <td style={{ border: "none" }}>
                  <span className="d-flex align-items-center">
                    Net Profit
                  </span>
                </td>
                <td style={{ border: "none" }}></td>
                <td
                  className="text-end"
                  style={{
                    color:
                    parentDatas.profitAndLossDatas2?.netProfit < 0
                        ? "red"
                        : "inherit",
                    border: "none",
                  }}
                >
                  {parentDatas.profitAndLossDatas2?.netProfit?.toFixed(2)}
                </td>
              </tr>

              <tr style={{ border: "1px solid rgb(224 224 224)" }}>
                <td style={{ fontWeight: "bold" }}>
                  <span className="d-flex align-items-center">
                    Total
                  </span>
                </td>
                <td></td>
                <td
                  className="text-end fw-bold"
                  style={{
                    color:
                    parentDatas.profitAndLossDatas2?.netAmount < 0
                        ? "red"
                        : "inherit",
                  }}
                >
                  {parentDatas.profitAndLossDatas2?.netAmount?.toFixed(2)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        

        <div
          className="card card-borderless py-2"
          style={{ width: "49%", padding: "0 10px" }}
        >
          <h2 style={{ textAlign: "center" }}>Income</h2>
          <div
            className="d-flex justify-content-between p-2"
            style={{ backgroundColor: "#EAF2E3" }}
          >
            <strong className="m-0 d-inline-flex">
              Particular{" "}
            </strong>

            <strong className="m-0 d-inline-flex">
              Amount ({currency})
            </strong>
          </div>
          <table className="mb-4 " style={{ width: "100%" }}>
            <thead>
              <tr style={{ backgroundColor: "transparent" }}>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(parentDatas.profitAndLossDatas1?.tradingTable) &&
                parentDatas.profitAndLossDatas1.tradingTable.map((type, i) => (
                  <React.Fragment key={i}>
                    {Array.isArray(type.subTradeTable) &&
                      type.subTradeTable.map((category, j) => (
                        <React.Fragment key={j}>
                          <tr
                            style={{
                              border: "1px solid rgb(224 224 224)",
                            }}
                          >
                            <td style={{ border: "none" }}>
                              <span className="d-flex align-items-center">
                                {category.particulars}{" "}
                              </span>
                            </td>
                            <td
                              className="text-end"
                              style={{
                                color:
                                  category?.amount < 0
                                    ? "red"
                                    : "inherit",
                              }}
                            >
                              {category?.amount.toFixed(2)}
                            </td>
                            <td style={{ border: "none" }}></td>
                          </tr>
                          {parentDatas.expandedCategories[j] &&
                            Array.isArray(category.subTradeTable) &&
                            category.subTradeTable.map(
                              (item, k) => (
                                <tr
                                  key={k}
                                  style={{
                                    border:
                                      "1px solid rgb(224 224 224)",
                                  }}
                                >
                                  <td className="ps-3">
                                    {item.parentParticular}
                                  </td>
                                  <td
                                    className="text-end"
                                    style={{
                                      border: "none",
                                      color:
                                        item?.amount < 0
                                          ? "red"
                                          : "inherit",
                                    }}
                                  >
                                    {item?.amount.toFixed(2)}
                                  </td>
                                </tr>
                              )
                            )}
                        </React.Fragment>
                      ))}
                    <tr
                      style={{
                        border: "1px solid rgb(224 224 224)",
                      }}
                    >
                      <td style={{ border: "none" }}>
                        <span className="d-flex align-items-center">
                          {type.particulars}{" "}
                        </span>
                      </td>
                      <td style={{ border: "none" }}></td>
                      <td
                        className="text-end"
                        style={{
                          border: "none",
                          color:
                            type?.amount < 0 ? "red" : "inherit",
                        }}
                      >
                        {type?.amount?.toFixed(2)}
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              {Array.isArray(parentDatas.profitAndLossDatas1?.directCategory) &&
                parentDatas.profitAndLossDatas1.directCategory.map(
                  (type, i) => (
                    <React.Fragment key={i}>
                      <tr
                        style={{
                          cursor: "pointer",
                          border: "1px solid rgb(224 224 224)",
                        }}
                      >
                        <td
                          onClick={() =>
                            parentDatas.toggleCategory(type.categoryID)
                          }
                          style={{ border: "none" }}
                        >
                          <span className="d-flex align-items-center ">
                            {type.coaCategoryName}{" "}
                            <i
                              className={`pi ${
                                parentDatas.expandedCategories[type.categoryID]
                                  ? "pi-angle-down"
                                  : "pi-angle-right"
                              } ms-2`}
                            ></i>
                          </span>
                        </td>
                        <td style={{ border: "none" }}></td>
                        <td
                          className="text-end"
                          style={{
                            border: "none",
                            color:
                              type?.total < 0 ? "red" : "inherit",
                          }}
                        >
                          {type?.total?.toFixed(2)}
                        </td>
                      </tr>

                      {parentDatas.expandedCategories[type.categoryID] &&
                        type.masCOAList.map((item) => (
                          <tr
                            key={item.coaMasID}
                            style={{
                              border: "1px solid rgb(224 224 224)",
                            }}
                          >
                            <td className="ps-3">{item.coaName}</td>
                            <td></td>
                            <td
                              className="text-end"
                              style={{
                                border: "none",
                                color:
                                  item.amount < 0
                                    ? "red"
                                    : "inherit",
                              }}
                            >
                              {item.amount?.toFixed(2)}
                            </td>
                          </tr>
                        ))}
                    </React.Fragment>
                  )
                )}
              <tr style={{ border: "1px solid rgb(224 224 224)" }}>
                <td style={{ border: "none" }}>
                  <span className="d-flex align-items-center">
                    Gross Loss
                  </span>
                </td>
                <td style={{ border: "none" }}></td>
                <td
                  className="text-end"
                  style={{
                    border: "none",
                    color:
                    parentDatas.profitAndLossDatas1?.grossProfit < 0
                        ? "red"
                        : "inherit",
                  }}
                >
                  {parentDatas.profitAndLossDatas1?.grossProfit?.toFixed(2)}
                </td>
              </tr>
              <tr style={{ border: "1px solid rgb(224 224 224)" }}>
                <td style={{ border: "none", fontWeight: "bold" }}>
                  <span className="d-flex align-items-center">
                    Total
                  </span>
                </td>
                <td style={{ border: "none" }}></td>
                <td
                  className="text-end fw-bold"
                  style={{
                    border: "none",
                    color:
                    parentDatas.profitAndLossDatas1?.grossAmount < 0
                        ? "red"
                        : "inherit",
                  }}
                >
                  {parentDatas.profitAndLossDatas1?.grossAmount?.toFixed(2)}
                </td>
              </tr>
              <tr style={{ border: "1px solid rgb(224 224 224)" }}>
                <td style={{ border: "none" }}>
                  <span className="d-flex align-items-center">
                    Gross Profit
                  </span>
                </td>
                <td style={{ border: "none" }}></td>
                <td
                  className="text-end"
                  style={{
                    border: "none",
                    color:
                    parentDatas.profitAndLossDatas1?.switchGrossProfit < 0
                        ? "red"
                        : "inherit",
                  }}
                >
                  {parentDatas.profitAndLossDatas1?.switchGrossProfit?.toFixed(
                    2
                  )}
                </td>
              </tr>
              {Array.isArray(
                parentDatas.profitAndLossDatas1?.inDirectCategory
              ) &&
              parentDatas.profitAndLossDatas1.inDirectCategory.map(
                  (type, i) => (
                    <React.Fragment key={i}>
                      <tr
                        style={{
                          cursor: "pointer",
                          border: "1px solid rgb(224 224 224)",
                        }}
                      >
                        <td
                          onClick={() =>
                            parentDatas.toggleCategory(type.categoryID)
                          }
                          style={{ border: "none" }}
                        >
                          <span className="d-flex align-items-center ">
                            {type.coaCategoryName}{" "}
                            <i
                              className={`pi ${
                                parentDatas.expandedCategories[type.categoryID]
                                  ? "pi-angle-down"
                                  : "pi-angle-right"
                              } ms-2`}
                            ></i>
                          </span>
                        </td>
                        <td style={{ border: "none" }}></td>
                        <td
                          className="text-end"
                          style={{
                            border: "none",
                            color:
                              type?.total < 0 ? "red" : "inherit",
                          }}
                        >
                          {type?.total?.toFixed(2)}
                        </td>
                      </tr>

                      {parentDatas.expandedCategories[type.categoryID] &&
                        type.masCOAList.map((item) => (
                          <tr
                            key={item.coaMasID}
                            style={{
                              border: "1px solid rgb(224 224 224)",
                            }}
                          >
                            <td className="ps-3">{item.coaName}</td>
                            <td></td>
                            <td
                              className="text-end"
                              style={{
                                border: "none",
                                color:
                                  item.amount < 0
                                    ? "red"
                                    : "inherit",
                              }}
                            >
                              {item.amount?.toFixed(2)}
                            </td>
                          </tr>
                        ))}
                    </React.Fragment>
                  )
                )}
              <tr style={{ border: "1px solid rgb(224 224 224)" }}>
                <td style={{ border: "none" }}>
                  <span className="d-flex align-items-center">
                    Net Loss
                  </span>
                </td>
                <td style={{ border: "none" }}></td>
                <td
                  className="text-end"
                  style={{
                    border: "none",
                    color:
                    parentDatas.profitAndLossDatas1?.netProfit < 0
                        ? "red"
                        : "inherit",
                  }}
                >
                  {parentDatas.profitAndLossDatas1?.netProfit?.toFixed(2)}
                </td>
              </tr>
              <tr style={{ border: "1px solid rgb(224 224 224)" }}>
                <td className='fw-5' style={{ border: "none", fontWeight:"bold" }}>
                  <span className="d-flex align-items-center">
                    Total
                  </span>
                </td>
                <td style={{ border: "none" }}></td>
                <td
                  className="text-end"
                  style={{
                    border: "none", fontWeight:"bold",
                    color:
                    parentDatas.profitAndLossDatas1?.netAmount < 0
                        ? "red"
                        : "inherit",
                  }}
                >
                  {parentDatas.profitAndLossDatas1?.netAmount?.toFixed(2)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    )}
  </div>
  )
}

export default ProfitandLoss